import { Box, Typography } from '@mui/material';
import styled from '@mui/material/styles/styled';

const ToggleContainer = styled(Box)(({ theme }) => ({
  display: 'inline-flex',
  borderRadius: '24px',
  border: `1px solid ${theme.palette.grey[200]}`,
  backgroundColor: theme.palette.grey[50],
  padding: '4px',
  position: 'relative',
}));

const ToggleButton = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'active',
})(({ theme, active }) => ({
  padding: '8px 20px',
  borderRadius: '20px',
  cursor: 'pointer',
  transition: 'all 0.2s ease',
  backgroundColor: active ? theme.palette.background.paper : 'transparent',
  border: active ? `1px solid ${theme.palette.grey[300]}` : '1px solid transparent',
  boxShadow: active ? theme.shadows[1] : 'none',
  userSelect: 'none',
}));

const Badge = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '-10px',
  right: '-4px',
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.common.white,
  borderRadius: '10px',
  padding: '1px 8px',
  fontSize: '11px',
  fontWeight: 600,
  lineHeight: '18px',
}));

const PricingToggle = ({ value, onChange, options, badgeText }) => (
  <ToggleContainer>
    {options.map((option) => (
      <ToggleButton key={option.value} active={value === option.value} onClick={() => onChange(option.value)}>
        <Typography variant="caption" fontWeight={600} color="accent.900">
          {option.label}
        </Typography>
      </ToggleButton>
    ))}
    {badgeText && <Badge>{badgeText}</Badge>}
  </ToggleContainer>
);

export default PricingToggle;
